<template>
  <div>
    <b-card :title="isEdit ? $t('settings.authority.edit') : $t('settings.authority.add')">
      <validation-observer
        ref="form"
        #default="{ handleSubmit }"
      >
        <b-form @submit.prevent="handleSubmit(onSubmit)">
          <b-row>
            <b-col
              cols="12"
              md="6"
            >
              <validation-provider
                #default="{ errors }"
                name="authority_name"
                rules="required"
              >
                <b-form-group
                  :label="$t('settings.authority.authority_name')"
                  label-for="authority_name"
                >
                  <b-form-input
                    id="authority_name"
                    v-model="form.authority_name"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t('settings.authority.authority_name')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col
              cols="12"
              md="6"
            >
              <validation-provider
                #default="{ errors }"
                name="authority_type"
                rules="required"
              >
                <b-form-group
                  :label="$t('settings.authority.authority_type')"
                  label-for="authority_type"
                >
                  <b-form-select
                    id="authority_type"
                    v-model="form.authority_type"
                    :options="authorityTypeOptions"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col
              cols="12"
              md="6"
            >
              <validation-provider
                #default="{ errors }"
                name="governorate_id"
                rules="required"
              >
                <b-form-group
                  :label="$t('settings.authority.governorate_id')"
                  label-for="governorate_id"
                >
                  <v-select
                    id="governorate_id"
                    v-model="form.governorate_id"
                    :options="governoratesDropdown"
                    :reduce="val => val.id"
                    label="name_ar"
                    :placeholder="$t('settings.authority.governorate_id')"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col
              cols="12"
              md="6"
            >
              <validation-provider
                #default="{ errors }"
                name="contact_person"
              >
                <b-form-group
                  :label="$t('settings.authority.contact_person')"
                  label-for="contact_person"
                >
                  <b-form-input
                    id="contact_person"
                    v-model="form.contact_person"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t('settings.authority.contact_person')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col
              cols="12"
              md="6"
            >
              <validation-provider
                #default="{ errors }"
                name="phone"
              >
                <b-form-group
                  :label="$t('settings.authority.phone')"
                  label-for="phone"
                >
                  <b-form-input
                    id="phone"
                    v-model="form.phone"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t('settings.authority.phone')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col
              cols="12"
              md="6"
            >
              <validation-provider
                #default="{ errors }"
                name="email"
                rules="email"
              >
                <b-form-group
                  :label="$t('settings.authority.email')"
                  label-for="email"
                >
                  <b-form-input
                    id="email"
                    v-model="form.email"
                    type="email"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t('settings.authority.email')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12">
              <validation-provider
                #default="{ errors }"
                name="address"
              >
                <b-form-group
                  :label="$t('settings.authority.address')"
                  label-for="address"
                >
                  <b-form-textarea
                    id="address"
                    v-model="form.address"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t('settings.authority.address')"
                    rows="3"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col
              cols="12"
              md="6"
            >
              <b-form-group :label="$t('settings.authority.is_active')">
                <b-form-checkbox
                  v-model="form.is_active"
                  switch
                >
                  {{ form.is_active ? $t('common.active') : $t('common.inactive') }}
                </b-form-checkbox>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-button
                type="submit"
                variant="primary"
                class="mr-1"
              >
                {{ $t('common.save') }}
              </b-button>
              <b-button
                variant="outline-secondary"
                @click="$router.go(-1)"
              >
                {{ $t('common.cancel') }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BForm, BRow, BCol, BFormGroup, BFormInput, BFormSelect, BFormTextarea, BFormCheckbox, BButton,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'
import { mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormTextarea,
    BFormCheckbox,
    BButton,
    ValidationObserver,
    ValidationProvider,
    vSelect,
  },
  data() {
    return {
      form: {
        authority_name: '',
        authority_type: null,
        governorate_id: null,
        contact_person: '',
        phone: '',
        email: '',
        address: '',
        is_active: true,
      },
      required,
    }
  },
  computed: {
    ...mapGetters({
      governoratesDropdown: 'governorates/dropdown',
    }),
    isEdit() {
      return !!this.$route.params.id
    },
    authorityTypeOptions() {
      return [
        { value: 'government', text: this.$t('settings.authority.types.government') },
        { value: 'private', text: this.$t('settings.authority.types.private') },
        { value: 'military', text: this.$t('settings.authority.types.military') },
        { value: 'religious', text: this.$t('settings.authority.types.religious') },
      ]
    },
  },
  mounted() {
    this.fetchGovernoratesDropdown()
    if (this.isEdit) {
      this.fetchAuthority()
    }
  },
  methods: {
    fetchGovernoratesDropdown() {
      this.$store.dispatch('governorates/dropdown')
    },
    fetchAuthority() {
      this.$store.dispatch('authorities/get', this.$route.params.id)
        .then(response => {
          this.form = { ...response.data }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('common.error'),
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              text: (error.response && error.response.data && error.response.data.message) || error.message,
            },
          })
        })
    },
    onSubmit() {
      const action = this.isEdit ? 'update' : 'create'
      const payload = this.isEdit ? { id: this.$route.params.id, data: this.form } : this.form

      this.$store.dispatch(`authorities/${action}`, payload)
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('common.success'),
              icon: 'CheckIcon',
              variant: 'success',
              text: this.isEdit
                ? this.$t('settings.authority.messages.update_success')
                : this.$t('settings.authority.messages.create_success'),
            },
          })
          this.$router.push({ name: 'settings-authorities' })
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('common.error'),
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              text: (error.response && error.response.data && error.response.data.message) || error.message,
            },
          })
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@core/scss/vue/libs/vue-select.scss';
</style>
